import { render, staticRenderFns } from "./LapidusPayments.vue?vue&type=template&id=370d2508&"
import script from "./LapidusPayments.vue?vue&type=script&lang=js&"
export * from "./LapidusPayments.vue?vue&type=script&lang=js&"
import style0 from "./LapidusPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports